<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span v-if="mode === modalWindowTypes.CREATE">Add new condition</span>
              <span v-if="mode === modalWindowTypes.EDIT">Edit condition</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  class="form-control"
                  v-model="models.name"
                  type="text"
                  placeholder="Please input query"
                />
                <br>
                <span>?</span>
              </div>
              <div
                v-for="(q, index) in models.questions"
                :key="index"
                class="form-group"
              >
                <input
                  class="form-control"
                  :value="q"
                  type="text"
                  placeholder="Please input result"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="mode === modalWindowTypes.CREATE"
            class="btn btn-success"
            @click="add()"
          >
            Add
          </button>
          <button
            v-if="mode === modalWindowTypes.EDIT"
            class="btn btn-success"
            @click="save()"
          >
            Save
          </button>
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'ModalCondition',
  props: {
    model: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: modalWindowTypes.CREATE
    }
  },
  data: () => (
    {
      prefix: 'Does the contact match the following conditions?',
      models: {
        text: '',
        name: '',
        questions: ['Yes', 'No']
      }
    }
  ),
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    }
  },
  mounted() {
    if (this.model !== null) {
      this.updateData()
    }
  },
  methods: {
    add() {
      this.setTextAndIcon()
      this.$emit('add', { ...this.$data.models })
    },
    save() {
      this.setTextAndIcon()
      this.$emit('save', { ...this.$data.models })
      this.clearData()
    },
    close() {
      this.$emit('close')
    },
    updateData() {
      for (const key in this.models) {
        this.models[key] = this.model.value[key]
      }
    },
    setTextAndIcon() {
      this.models.text = `${this.prefix} (${this.models.name})`
    },
    clearData() {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalCondition.vue